import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#e51b5e',
        secondary: '#F0F8FF',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#e51b5e',
        success: '#4CAF50',
        warning: '#ff0000',
        send_button: '#f0f8ff'
      }
    }
  }
})
